import Vue from 'vue';
import Vuex from 'vuex';

import communication from './modules/communication';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    // menuState: '',
  },
  mutations: {
    // storeMenuState (state, menuState) {
    //   state.menuState = menuState
    // }
  },
  actions: {
    // setMenuState ({commit}, menuState) {
    //   commit(storeMenuState, menuState)
    // }
  },
  getters: {
    // menuState (state) {
    //   return state.menuState
    // },
  },
  modules: {
    communication,
  }
});



// WEBPACK FOOTER //
// ./src/store/store.js